import axios from 'axios';
import { Global_ISDA_Functions } from '../global/global';

(function( $ ) {
		class BookStoreCart {
			constructor() {
				this.nonce = wpApiSettings.nonce;
				this.endpoint = `${ wpApiSettings.root }isda/v1/cart/`;
			}

			saveCart( cart ) {
				this.saveCartToLocalStorage( cart );
				this.saveCartToServer( cart );
			}

			isUserLoggedIn() {
				return this.containsClass( document.body, 'logged-in' );
			}

			containsClass( elem, yourClass ) {
				if ( !elem || typeof yourClass !== 'string' ) {
					return false;
				} else if ( elem.className && elem.className.trim()
				                                  .split( /\s+/gi )
				                                  .indexOf( yourClass ) > -1 ) {
					return true;
				} else {
					return false;
				}
			}

			localStorageTest() {
				const test = 'test';
				try {
					localStorage.setItem( test, test );
					localStorage.removeItem( test );
					return true;
				} catch ( e ) {
					return false;
				}
			}

			clearCartInLocalStorage() {
				localStorage.removeItem( 'bookstoreCart' );
			}

			saveCartToLocalStorage( cart ) {
				if ( this.localStorageTest() ) {
					localStorage.setItem( 'bookstoreCart', JSON.stringify( cart ) );
					return true;
				}
				return false;
			}

			addToCart( cart, item, quantity = 1 ) {
				let updateCart = Object.assign( {}, cart );
				if ( 'undefined' !== typeof cart[ item ] ) {
					updateCart[ item ] = parseInt( cart[ item ] ) + parseInt( quantity );
				} else {
					updateCart[ item ] = parseInt( quantity );
				}

				return updateCart;
			}

			getCartFromLocalStorage() {
				if ( this.localStorageTest() ) {
					const bookstoreCart = localStorage.getItem( 'bookstoreCart' );
					if ( 'undefined' !== bookstoreCart ) {
						return JSON.parse( bookstoreCart );
					}
				}
				return false;
			}

			isCartEmpty( cart ) {
				return Array.isArray( cart ) && !cart.length;
			}

			getCartFromServer() {
				axios( {
					       method: 'GET', url: this.endpoint, data: {
						nonce: this.nonce
					}, headers   : { 'X-WP-Nonce': this.nonce }
				       } ).then( response => {
					$( document ).trigger( 'receivedCart', response.data ); // todo: do without jQuery
				} );
			}

			saveCartToServer( cart ) {
				//check if the user is on the cart page
				const isCartPage = window.location.pathname.includes( 'cart' );
				if ( this.isUserLoggedIn() && !isCartPage ) {
					axios( {
						       method: 'POST', url: this.endpoint, data: {
							items: cart, nonce: this.nonce
						}, headers   : { 'X-WP-Nonce': this.nonce }
					       } ).then( response => {
						// console.log("Cart Saved", response);
					} );
				}
			}

			clearCartOnServer() {
				if ( this.isUserLoggedIn() ) {
					axios( {
						       method: 'DELETE', url: this.endpoint, data: {
							nonce: this.nonce
						}, headers   : { 'X-WP-Nonce': this.nonce }
					       } ).then( response => {
						// console.log("Cart Deleted", response);
					} );
				}
			}

			calculateCartCount( cart ) {
				var quantities = Object.values( cart );
				return (quantities.length
				       ) ? quantities.reduce( function( acc, val ) {
					return parseInt( acc ) + parseInt( val );
				} ) : 0;
			}

			buildCartUrl( cart ) {
				// let productsUrl = '';
				// Object.keys( cart ).forEach( key => {
				// 	'use strict';
				// 	productsUrl += `|${key},${cart[ key ]}`;
				// } );

				// return productsUrl.substring( 1 );
			}

		}

		function calcuateCartTotalFromCheckout() {
			let total = 0;
			$( '#bookstore-cart .row' ).each( function( i, elem ) {
				const quantity = $( 'input[type=number]', elem ).val(),
				      price    = $( '.nonmember-price', elem ).text();

				if ( 'undefined' !== typeof quantity && quantity > 0 ) {
					total += parseInt( quantity ) * parseInt( price );
				}
			} );
			return total;
		}

		function updateCartTotal( total ) {
			$( '.total-formatted' ).text( total.toFixed( 2 ) );
		}

		function updateFixedNavMenuCartUrl( cart ) {
			const bookstoreCart = new BookStoreCart();
			const cartCount = bookstoreCart.calculateCartCount( cart );
			const cartUrl = bookstoreCart.buildCartUrl( cart );
			const homeUrl = (typeof ISDA_Main.home_url !== 'undefined'
			                ) ? ISDA_Main.home_url : '';
			const isCartPage = window.location.pathname.includes( 'cart' );
			if ( !isCartPage ) {
				if ( cartCount > 0 ) {
					$( '.cart-quantity' ).removeClass( 'hide' );
					$( '.cart-quantity' ).text( cartCount );
				} else {
					$( '.cart-quantity' ).addClass( 'hide' );
				}
			}
			// $( '#top-navigation .link-cart' )
			// 	.attr( 'href', `${homeUrl}/books/cart/?products=${cartUrl}` );
		}

		function generateCartFromCheckout() {
			let reGeneratedCart = {};
			$( '#bookstore-cart input[type=number]' )
				.each( function( i, elem ) {
					const product  = $( elem ).attr( 'name' ).slice( 9, -1 ),
					      quantity = $( elem ).val();
					reGeneratedCart[ `${ product }` ] = quantity;
				} );
			return reGeneratedCart;
		}

		function pushCartUrl( cartUrl ) {
			//pushstate not supported in IE9
			history.pushState( {}, 'Cart - International Swaps and Derivatives Association', `/books/cart/?products=${ cartUrl }` );
		}

		function removeCartRow( row ) {
			$( row ).remove();
		}

		// function clearCartOnclick() {
		// 	// let cartEmptyText = '<p>Your cart is empty</p>';
		// 	// $( '.line-item' ).each( function( index, element ) {
		// 	// 	element.parentNode.removeChild( element );
		// 	// } );

		// 	// $( '.row.cart-empty-message' ).show().html( cartEmptyText );
		// 	// $( '#bookstore-cart-ol-msg' ).hide();
		// 	// $( '.clear-entire-cart-btn' ).hide();

		// 	rebuildUpdateCartDataFromCheckout();
		// }

		function rebuildUpdateCartDataFromCheckout() {
			const bookstoreCart = new BookStoreCart();
			const cart = generateCartFromCheckout();
			const total = calcuateCartTotalFromCheckout();
			const url = bookstoreCart.buildCartUrl( cart );

			bookstoreCart.saveCart( cart );

			updateFixedNavMenuCartUrl( cart );
			// updateCartTotal( total );
			// pushCartUrl( url );
		}

		function showAddedMessage( imisNum ) {
			$( '.added-to-cart-msg[data-imiscode="' + imisNum + '"]' )
				.fadeIn( 300 ).delay( 2000 ).fadeOut( 300 );
		}

		$( document ).on( 'receivedCart', ( event, serverCart ) => {
			const bookstoreCart = new BookStoreCart();
			// console.log("RETRIEVED CART", serverCart);

			if ( serverCart.shouldDelete ) {
				// delete local cart if logs out
				bookstoreCart.clearCartInLocalStorage();
			}

			const localCart = bookstoreCart.getCartFromLocalStorage() || [];

			// if user logs in with an empty cart, they should get the server cart. Otherwise they should get local cart.
			const cart = bookstoreCart.isCartEmpty( localCart )
			             ? serverCart.cart
			             : localCart;
			console.log( 'CART CART', cart );
			if ( JSON.stringify( localCart ) !== JSON.stringify( serverCart ) ) {
				bookstoreCart.saveCart( cart );
			}

			updateFixedNavMenuCartUrl( cart );
		} );

		$( document ).ready( function() {
			const bookstoreCart = new BookStoreCart();
			bookstoreCart.getCartFromServer();

			// if ( $( '#bookstore-cart' ).length ) {
			// 	/* you're on the bookstore page */
			// 	const cart = generateCartFromCheckout();
			// 	bookstoreCart.saveCart( cart );
			// 	updateFixedNavMenuCartUrl( cart );
			// }

			/* you're anywhere on site */
			// retrieve cart
			// update fixed nav cart values
			$(document).on('click', '.btn-add-to-cart-login', function(e) {
				e.preventDefault();
									//books main page
									if ( $( 'body' ).hasClass( 'post-type-archive-book' ) ) {
										var elements = '#main section, #bookstore-catalog-view, .bookstore-library-toggle, .blue-hero, .bookstore-desc';
									}
				
									//books item page
									if ( $( 'body' ).hasClass( 'single-book' ) ) {
										var elements = '.bookstore-item, .bookstore-library-toggle';
									}
				
									//ondemand main page
									if ( $( 'body' ).hasClass( 'post-type-archive-event' ) ) {
										var elements = '.react-fallback, .isda-on-demand, .event-topic-suggestions, .events-contact';
									}
				
									//ondemand item page
									if ( $( 'body' ).hasClass( 'single-ondemand' ) ) {
										var elements = '.single-event-banner, .event-details-info';
									}
				
									$( elements ).hide();
				
									$( '#books-ondemand-login-block' ).show();
									$( '#bookstore-login-signup' ).show();
									$( '.login-close-icon' ).css( 'visibility', 'visible' );
				$( '#books-ondemand-login-block' )
					.attr( 'data-page-elements', elements );
			});


			$( document ).on( 'click', '.btn-add-to-cart', function( e ) {
				e.preventDefault();
				var bookObj = new BookStoreCart();
				if ( bookObj.isUserLoggedIn() ) {
					const itemToAdd = $( this ).data( 'imiscode' );
					let cart = bookstoreCart.getCartFromLocalStorage();
					cart = bookstoreCart.addToCart( cart, itemToAdd );
					bookstoreCart.saveCart( cart );

					updateFixedNavMenuCartUrl( cart );

					// showAddedMessage(itemToAdd);
					const originalHtml = $( this ).html();
					$( this ).html( 'Added to Cart' );
					$( this ).addClass( 'added-to-cart' );
					$( this ).removeClass( 'btn-default' );
					setTimeout( () => {
						$( this ).addClass( 'btn-default' );
						$( this ).removeClass( 'added-to-cart' );
						if ( $( this ).hasClass( 'kinetix' ) || $( this ).hasClass( 'e-book' ) || $( this ).hasClass( 'gift-button' ) && ISDA_Main.libraryAccessStatus !== 'PLUS' || $( this ).hasClass( 'btn-on-demand' ) ) {
							$( this ).html( 'Item in Cart' );
							$( this ).removeClass( 'btn-add-to-cart' );
							$(this).attr('disabled', true);
						} else{

							$( this ).html( originalHtml );
						}
					}, 1500 );
				//TODO : THE ELSE CAN BE REMOVED WHEN ALL OTHER BTNS HAVE btn-add-to-cart-login
				} else {
					//books main page
					if ( $( 'body' ).hasClass( 'post-type-archive-book' ) ) {
						var elements = '#main section, #bookstore-catalog-view, .bookstore-library-toggle, .blue-hero, .bookstore-desc';
					}

					//books item page
					if ( $( 'body' ).hasClass( 'single-book' ) ) {
						var elements = '.bookstore-item, .bookstore-library-toggle';
					}

					//ondemand main page
					if ( $( 'body' ).hasClass( 'post-type-archive-event' ) ) {
						var elements = '.react-fallback, .isda-on-demand, .event-topic-suggestions, .events-contact';
					}

					//ondemand item page
					if ( $( 'body' ).hasClass( 'single-ondemand' ) ) {
						var elements = '.single-event-banner, .event-details-info';
					}

					$( elements ).hide();

					$( '#books-ondemand-login-block' ).show();
					$( '.login-close-icon' ).css( 'visibility', 'visible' );
					$( '#books-ondemand-login-block' )
						.attr( 'data-page-elements', elements );
				}
			} );

			$( '.login-close-icon' ).click( function() {
				$( '#books-ondemand-login-block' ).hide();
				$( '.login-close-icon' ).css( 'visibility', 'hidden' );
				$( '#bookstore-login-signup' ).hide();
				var elements = $( '#books-ondemand-login-block' )
					.attr( 'data-page-elements' );
				$( elements ).show();
			} );

			// $( '#bookstore-cart .product-qty-field' ).change( function( e ) {
			// 	let qtyField      = $( this ),
			// 		qtyVal        = qtyField.val(),
			// 	    thisRow       = qtyField.closest( '.line-item' ),
			// 	    removeThisBtn = thisRow.find( '.remove-item' );

			// 	//if value is manually set to 0 or a negative numer, will remove item from cart
			// 	if ( qtyVal <= 0 ) {
			// 		removeThisBtn.trigger( 'click' );
			// 	} else {
			// 		rebuildUpdateCartDataFromCheckout();
			// 	}
			// } );

			$( '#bookstore-cart' )
				.on( 'change input', '.product-qty-field', function( e ) {
					handleQuantityChange( $( this ) );
				} );

			// Add a custom event listener for programmatic updates
			$( '#bookstore-cart' )
				.on( 'quantityUpdated', '.product-qty-field', function( e ) {
					handleQuantityChange( $( this ) );
				} );

			$( '#bookstore-cart' )
				.on( 'click', '.btn-change-quantity', function( e ) {
					e.preventDefault();
					const qtyField = $( this ).closest( '.line-item' )
					                          .find( '.product-qty-field' );
					const currentVal = parseInt( qtyField.val(), 10 );
					const step = $( this ).hasClass( 'increase' ) ? 1 : -1;
					const newVal = Math.max( 0, currentVal + step );

					qtyField.val( newVal ).trigger( 'change' );
				} );

			function handleQuantityChange( qtyField ) {
				let qtyVal        = parseInt( qtyField.val(), 10 ),
				    thisRow       = qtyField.closest( '.line-item' ),
				    removeThisBtn = thisRow.find( '.remove-item' );

				if ( qtyVal <= 0 ) {
					removeThisBtn.trigger( 'click' );
				} else {
					rebuildUpdateCartDataFromCheckout();
				}
			}

			//THIS IS NOW DONE IN REACT
			// $( 'body.page-template-page-bookstore-cart .remove-item' )
			// 	.click( function( e ) {
			// 		e.preventDefault();

			// 		let lineItem = $( '.page-template-page-bookstore-cart' )
			// 			.find( '.line-item' );
			// 		removeCartRow( $( e.target ).closest( '.row' ) );
			// 		if ( lineItem.length === 1 ) {
			// 			clearCartOnclick();
			// 		}
			// 		rebuildUpdateCartDataFromCheckout();
			// 	} );

			//THIS IS NOW DONE IN REACT
			// $( 'body.page-template-page-bookstore-cart .clear-entire-cart-btn' )
			// 	.on( 'click', function( e ) {
			// 		// e.preventDefault();
			// 		console.log(' Going to rebuild')
			// 		rebuildUpdateCartDataFromCheckout();
			// 	} );
		} );
	}
)( jQuery );
